import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

const TabContainer = styled.ul`
  display: flex;
  margin: 15px 0 0 0;
  list-style: none;
`;

const Tab = styled.li`
  display: inline-block;
  text-align: center;
  font-size: 18px;
  line-height: 21px;
  width: 160px;
  height: 50px;
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }
`;

const ButtonLink = styled.a`
  text-decoration: none;
  transition: color 0.1s, background-color 0.1s;
  color: #00b2ca;
  &::before {
    content: '';
    display: block;
    position: relative;
    bottom: -45px;
    left: 0;
    height: 3px;
    width: 100%;
    background-color: #00b2ca;
    transform-origin: right top;
    transform: scale(0, 1);
    transition: color 0.1s, transform 0.2s ease-out;
  }
  &.active::before {
    background-color: #00b2ca;
    transform-origin: left top;
    transform: scale(1, 1);
  }
  &:hover::before,
  &:focus::before {
    transform-origin: left top;
    transform: scale(1, 1);
  }
`;

const TabBar = ({ activeTab, onChangeTab }) => (
  <TabContainer>
    <Tab onClick={onChangeTab('activities')}>
      <ButtonLink className={activeTab === 'activities' ? 'active' : ''}>Activités pratiquées</ButtonLink>
    </Tab>
    <Tab onClick={onChangeTab('degree')}>
      <ButtonLink className={activeTab === 'degree' ? 'active' : ''}>Diplômes</ButtonLink>
    </Tab>
  </TabContainer>
);

TabBar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onChangeTab: PropTypes.func.isRequired
};

export default TabBar;



// WEBPACK FOOTER //
// ./src/components/CoachPanel/Tab/TabBar.jsx